import type { i18n } from 'i18next'
import { SupportedLanguages } from 'src/types/locale'

export const selectLanguage = (
  i18nArgs: Pick<i18n, 'changeLanguage'>,
  value: SupportedLanguages,
) => {
  i18nArgs.changeLanguage(value)
}
